import React from 'react';
import classes from './styles.module.scss';

const Heading = ({ text }) => {
  return <h5 className={classes.text}>{text}</h5>;
};

export default Heading;
